const personIcon = `
<svg width="10px" height="20px" viewBox="0 0 10 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>user-male</title>
    <desc>Created with Sketch.</desc>
    <g id="Dashboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Dashboard-empty-state-Copy" transform="translate(-327.000000, -218.000000)">
            <g id="Visitors-Copy" transform="translate(284.000000, 180.000000)">
                <g id="user-male" transform="translate(36.000000, 36.000000)">
                    <g id="Frame_-_24px">
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                    </g>
                    <g id="Line_Icons" transform="translate(7.000000, 2.000000)" fill="#00A3D9" fill-rule="nonzero">
                        <g id="Group">
                            <path d="M5.001,6 C3.347,6 2.001,4.654 2.001,3 C2.001,1.346 3.347,0 5.001,0 C6.655,0 8.001,1.346 8.001,3 C8.001,4.654 6.655,6 5.001,6 Z M5.001,2 C4.45,2 4.001,2.449 4.001,3 C4.001,3.551 4.45,4 5.001,4 C5.552,4 6.001,3.551 6.001,3 C6.001,2.449 5.552,2 5.001,2 Z" id="Shape"></path>
                            <path d="M7.001,20 L3.001,20 C2.449,20 2.001,19.552 2.001,19 L2.001,15 L1.001,15 C0.449,15 0.001,14.552 0.001,14 L0.001,11 C0.001,8.243 2.244,6 5.001,6 C7.758,6 10.001,8.243 10.001,11 L10.001,14 C10.001,14.552 9.553,15 9.001,15 L8.001,15 L8.001,19 C8.001,19.552 7.553,20 7.001,20 Z M4.001,18 L6.001,18 L6.001,14 C6.001,13.448 6.449,13 7.001,13 L8.001,13 L8.001,11 C8.001,9.346 6.655,8 5.001,8 C3.347,8 2.001,9.346 2.001,11 L2.001,13 L3.001,13 C3.553,13 4.001,13.448 4.001,14 L4.001,18 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default personIcon;
